import { apiFetch } from './client';
import type { ContinuityHome } from '$lib/types';

// continuityHomeApi backs the admin Continuity Home screen (Phase 4) —
// admin-only server-side (see internal/api/handlers/continuity_home.go).
export const continuityHomeApi = {
  get: () => apiFetch<ContinuityHome>('/admin/continuity/home'),
  startProofTest: (okrId: number) =>
    apiFetch<{ okr_id: number }>('/admin/continuity/home/start_proof_test', {
      method: 'POST',
      body: JSON.stringify({ okr_id: okrId })
    })
};
